import { render, staticRenderFns } from "./BasicInfoDetailCard.vue?vue&type=template&id=29830c8a&scoped=true"
import script from "./BasicInfoDetailCard.vue?vue&type=script&lang=js"
export * from "./BasicInfoDetailCard.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoDetailCard.vue?vue&type=style&index=0&id=29830c8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29830c8a",
  null
  
)

export default component.exports